export const init = () => {
  const fwk = CUBE.Analytics;
  const utils = fwk.utils;
  const sep = AnalyticsConstants.separatorST;

  /* ENHANCED E-COMMERCE - CROSS-SELL CART */
  if ($('#cart-cross-sell-right').length === 0) return;

  /**
   * CROSS SELL CART - IMPRESSION
   */
  $(window).on(
    'scroll',
    cube.debounce(() => {
      $('.cs-product:not(.viewed)').each(function() {
        const $product = $(this);
        if (utils.isVisible($product)) {
          $product.addClass('viewed');
          fwk.enhanced.sendImpression(getModel($product));
        }
      });
    }, 150)
  );

  /**
   * CROSS SELL CART - CLICK ON ADD TO CART
   *  > Update ShoppingTool informations
   */
  $('.cs-product').on('click', '.csp__cta a', function() {
    const model = getModel($(this).closest('.cs-product'));
    fwk.shoppingtool.setTmp(
      'merchandising',
      `cross-selling${sep}${fwk.utils.getInfoPage()}${sep}position${sep}${
        model.position
      }`,
      model.name + sep + model.id,
      model.price
    );
  });

  /**
   * CROSS SELL CART - ADD TO CART CONFIRMATION
   *  > Send EnhancedEcommerce AddToCart (and put back old EC inforamtions)
   *  > ShoppingTool is auto-send in addtocart.js in cas of success
   */
  $('.cs-product').on('confirm', function() {
    fwk.enhanced.sendAddToCart(getModel($(this)));
  });

  /**
   * UTIL METHOD : Generate a model based on a CART-CROSS-SELL $product element
   */
  const getModel = function($product) {
    return {
      id: $product.attr('data-anly-model-id'),
      type: 'LVP',
      name: $product
        .find('.csp__name')
        .text()
        .trim(),
      brand: $product.attr('data-anly-brand'),
      position: $('.cs-product').index($product) + 1,
      list: '/checkout/cart',
      variant: $product.attr('data-anly-nature'),
      category: $product.attr('data-anly-category'),
      quantity: 1,
      price: $product.find('.price').data('price'),
      vada: {
        family: $product.data('family') || '',
        department: $product.data('department') || '',
        subdepartment: $product.data('subdepartment') || '',
        universe: $product.data('universe') || '',
      },
      /**
       * TODO PARSING
       */
    };
  };
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-cart-cross-sell.js